import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ClockProperties } from "@lib/titan2/dist/game/control/properties/ClockProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Locale, LanguageManager } from "@lib/titan2/dist/game/manager/LanguageManager";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
export class AbstractMessageBarProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.messageFieldProperties.equals(other.messageFieldProperties) &&
            this.gameIdProperties.equals(other.gameIdProperties) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.clockProperties.equals(other.clockProperties) &&
            this.maxLength.getKeys().every((val, index) => val.is(other.maxLength.getKeys()[index])) &&
            this.maxLength.getValues().every((val, index) => val === other.maxLength.getValues()[index]) &&
            this.messageInterval === other.messageInterval;
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(SlingoStyle.MESSAGE_BAR_BACKGROUND, SlingoStyle.MODULE);
        this.messageFieldProperties = new TextFieldProperties(FontStyle.MESSAGE_BAR, null, null, ControlConstants.CENTER);
        this.gameIdProperties = new TextFieldProperties(FontStyle.MESSAGE_BAR, null, null, ControlConstants.LEFT);
        this.messageFieldProperties.autoResize = false;
        this.maxLength = new Dictionary();
        this.clockProperties = new ClockProperties(FontStyle.CLOCK);
        this.fieldOffset = 17;
        this.fullScreenOffset = 75;
    }
    getMaxLength() {
        let locale = LanguageManager.getInstance().getLocale();
        if (!this.maxLength.containsKey(locale)) {
            locale = Locale.ENGLISH;
        }
        return this.maxLength.getValue(locale);
    }
}
//# sourceMappingURL=AbstractMessageBarProperties.js.map